(function () {
    'use strict';

    run.admin.parts.adminMessages = function () {
        const queryString = window.location.search;
        if (queryString == null || queryString == 'undefined') {
            return;
        }

        const urlParams = new URLSearchParams(queryString);

        if (urlParams.has('plan_activated')) {
            const activated = urlParams.get('plan_activated');

            switch (activated) {
                case '0':
                    Swal.fire('Account upgrade canceled. You can always upgrade your account from the settings option.');
                    break;
                case '1':
                    Swal.fire('Thanks for upgrading! We hope you enjoy being a Rackoot Pro user!');
                    break;
            }
        }
    };
})();